import CHART_TYPES from '../charts'

import Partners from 'modules/crm/enums/partner-enum'
import NpsFilterOptions from '../helpers/nps-filter-options'

export default {
  reportingSitesNPS: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'For the satisfaction scores both free and paid customers are combined. These stats are updated every hour. The stats below show data for <brands all>'
      },
      {
        title: 'Satisfaction',
        type: CHART_TYPES.TABLE,
        name: 'nps',
        className: 'grid-col-6',
        tooltip:
          'A table with the scores and number of responses for the Traditional and Express Editor for all brands.',
        headers: [
          { name: 'Partner', title: 'Partner' },
          { name: 'ScoreEE', title: 'Score EE', type: 'number' },
          { name: 'RespondeesEE', title: 'Respondees EE', type: 'number' },
          { name: 'ScoreTraditional', title: 'Score Traditional', type: 'number' },
          { name: 'RespondeesTraditional', title: 'Respondees Traditional', type: 'number' }
        ]
      },
      {
        title: 'Satisfaction Customer Type',
        type: CHART_TYPES.COLUMN,
        customFormat: CHART_TYPES.SCORE_RESPONDEES,
        name: 'npsscorecombined',
        nps: true,
        yAxis: 'NPS',
        tooltip: 'The Satisfaction score for Free/Paid and for Traditional/Express customers.',
        customDataHandler: data => {
          const order = ['Free Customers Express', 'Paid Customers Express', 'Free Customers Traditional', 'Paid Customers Traditional', 'Direct', 'Hosting', 'Total']

          const d = []

          order.forEach(orderItem => {
            const find = data.find(item => item.data.find(i => i.value === orderItem))
            if (find) {
              d.push(find)
            }
          })

          return d
        }
      },
      {
        title: 'Satisfaction trend Express',
        type: CHART_TYPES.GRAPH,
        name: 'npstrendexpress',
        yAxis: 'NPS',
        customFormat: CHART_TYPES.BRAND_SITES,
        visible: ['Total Satisfaction'],
        userFriendlyLabels: true,
        nps: true,
        tooltip:
          'A graph with the Satisfaction trend for the Express Editor on specific dates (or periods if grouped on week, month or year). By default the Total Satisfaction is shown and specific brands can be enabled as well.'
      },
      {
        title: 'Satisfaction trend Traditional',
        type: CHART_TYPES.GRAPH,
        name: 'npstrendtraditional',
        yAxis: 'NPS',
        customFormat: CHART_TYPES.BRAND_SITES,
        visible: ['Total Satisfaction'],
        userFriendlyLabels: true,
        nps: true,
        isTraditional: true,
        tooltip:
          'A graph with the Satisfaction trend for the Traditional Editor on specific dates (or periods if grouped on week, month or year). By default the Total Satisfaction is shown and specific brands can be enabled as well.'
      },
      {
        title: 'Satisfaction per brand Traditional',
        type: CHART_TYPES.COLUMN,
        name: 'npsScorePerBrand',
        nps: true,
        isTraditional: true,
        yAxis: 'NPS',
        tooltip: 'The Satisfaction score for the Traditional Editor for all brands.'
      },
      {
        title: 'Satisfaction respondees per brand Traditional',
        type: CHART_TYPES.COLUMN,
        name: 'NpsResponsesPerBrand',
        isTraditional: true,
        tooltip: 'The number of Satisfaction responses for the Traditional Editor for all brands.'
      },
      {
        title: 'Supporting comments Express',
        type: CHART_TYPES.CARD,
        name: 'npssupportingcommentsExpress',
        tooltip: 'The total number of Supporting comments for the Express Editor in a certain period.'
      },
      {
        title: 'Supporting comments Traditional',
        type: CHART_TYPES.CARD,
        name: 'npssupportingcomments',
        isTraditional: true,
        tooltip: 'The total number of Supporting comments for the Traditional Editor in a certain period.'
      },
      {
        title: 'Satisfaction comments Express',
        type: CHART_TYPES.TABLE,
        name: 'npscommentsExpress',
        tooltip: 'A table showing all Supporting comments for the Express Editor in a certain period.',
        sorting: { default: { fieldNames: ['date'], direction: true } },
        enableCaching: false,
        isNpsTable: true,
        filters: NpsFilterOptions,
        headers: [
          {
            type: 'nps-multi-select',
            disableRouteClick: true
          },
          {
            name: 'AccountId',
            title: 'Account Id',
            type: 'account',
            disableRouteClick: true
          },
          {
            name: 'Email',
            title: 'Email',
            type: ''
          },
          {
            name: 'Phone',
            title: 'Phone',
            type: ''
          },
          {
            name: 'Partner',
            title: 'Partner',
            type: ''
          },
          {
            name: 'Score',
            title: 'Score',
            type: 'number'
          },
          {
            name: 'Comment',
            title: 'Comment',
            type: ''
          },
          {
            name: 'CustomerType',
            title: 'Customer Type',
            type: ''
          },
          {
            name: 'Date',
            title: 'Date',
            type: 'date'
          },
          {
            name: 'Time',
            title: 'Time',
            type: 'datetime'
          },
          {
            name: 'AgentId',
            title: 'Agent Id',
            type: ''
          },
          {
            name: 'Note',
            title: 'Note',
            type: ''
          },
          {
            name: 'Status',
            title: 'Status',
            type: ''
          },
          {
            type: 'nps-edit-column',
            disableRouteClick: true
          }
        ]
      },
      {
        title: 'Satisfaction comments Traditional',
        type: CHART_TYPES.TABLE,
        name: 'npscomments',
        tooltip: 'A table showing all Supporting comments for the Traditional Editor in a certain period.',
        sorting: { default: { fieldNames: ['date'], direction: true } },
        enableCaching: false,
        isTraditional: true,
        isNpsTable: true,
        filters: NpsFilterOptions,
        headers: [
          {
            type: 'nps-multi-select',
            disableRouteClick: true
          },
          {
            name: 'AccountId',
            title: 'Account Id',
            type: 'account',
            disableRouteClick: true
          },
          {
            name: 'Email',
            title: 'Email',
            type: ''
          },
          {
            name: 'Phone',
            title: 'Phone',
            type: ''
          },
          {
            name: 'Partner',
            title: 'Partner',
            type: ''
          },
          {
            name: 'Score',
            title: 'Score',
            type: 'number'
          },
          {
            name: 'Comment',
            title: 'Comment',
            type: ''
          },
          {
            name: 'CustomerType',
            title: 'Customer Type',
            type: ''
          },
          {
            name: 'Date',
            title: 'Date',
            type: 'date'
          },
          {
            name: 'Time',
            title: 'Time',
            type: 'datetime'
          },
          {
            name: 'AgentId',
            title: 'Agent Id',
            type: ''
          },
          {
            name: 'Note',
            title: 'Note',
            type: ''
          },
          {
            name: 'Status',
            title: 'Status',
            type: ''
          },
          {
            type: 'nps-edit-column',
            disableRouteClick: true
          }
        ]
      }
    ],
    route: '/financial-reports/site/nps',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.DOMAINCOM.id, Partners.BLUEHOST.id, Partners.BIGROCK.id]
  },
  reportingSitesOverview: {
    hideDatePicker: true,
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'The stats on this page make use of data available since the start of the product. These stats are updated every hour. The stats below show data for <brands all>'
      },
      {
        title: 'Total number of saved sites Express Editor',
        type: CHART_TYPES.CARD,
        name: 'totalCreatedSitesExpress',
        tooltip: 'The total number of saved sites since the start of the Express Editor.'
      },
      {
        title: 'Total number of active published sites Express Editor',
        type: CHART_TYPES.CARD,
        name: 'totalActivePublishedSitesExpress'
      },
      {
        title: 'Total number of saved sites Traditional Editor Builder',
        type: CHART_TYPES.CARD,
        name: 'TotalCreatedSitesTraditionalBuilder'
      },
      {
        title: 'Total number of active published sites Traditional Editor Builder',
        type: CHART_TYPES.CARD,
        name: 'TotalActivePublishedSitesTraditionalBuilder'
      },
      {
        title: 'Total number of saved sites Traditional Editor Hosting',
        type: CHART_TYPES.CARD,
        name: 'TotalCreatedSitesTraditionalHosting'
      },
      {
        title: 'Total number of active published sites Traditional Editor Hosting',
        type: CHART_TYPES.CARD,
        name: 'TotalActivePublishedSitesTraditionalHosting',
        tooltip: 'Total number of active published sites with the traditional editor'
      },
      {
        title: 'Saved and Published Site Totals',
        type: CHART_TYPES.TABLE,
        name: 'allbrandssavedandactive'
      }
    ],
    route: '/financial-reports/site/overview',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.DOMAINCOM.id, Partners.BLUEHOST.id, Partners.BIGROCK.id]
  },
  reportingSitesPublished: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title: 'These stats are updated every hour. The stats below show data for <brands all>'
      },
      // {
      //   title: 'Created sites Traditional Editor',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'createSitesEditor'
      // },
      // {
      //   title: 'Created sites Traditional Editor by brand',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'createSitesBrandEditor'
      // },
      // {
      //   title: 'Number of saved sites Traditional Editor Builder',
      //   type: CHART_TYPES.CARD,
      //   name: 'TotalCreatedSitesTraditionalBuilderInPeriod',
      //   tooltip: 'The total number of saved sites for builder brands with the traditional editor within the selected date range.'
      // },
      // {
      //   title: 'Number of saved sites Traditional Editor Hosting',
      //   type: CHART_TYPES.CARD,
      //   name: 'TotalCreatedSitesTraditionalHostingInPeriod',
      //   tooltip: 'The total number of saved sites for hosting brands with the traditional editor within the selected date range.'
      // },
      // {
      //   title: 'Number of saved sites Express Editor',
      //   type: CHART_TYPES.CARD,
      //   name: 'totalCreatedSitesExpressInPeriod',
      //   tooltip: 'The total number of saved sites for the express editor within the selected date range.'
      // },
      // {
      //   title: 'Total number of active published sites Traditional Editor Builder',
      //   type: CHART_TYPES.CARD,
      //   name: 'TotalActivePublishedSitesTraditionalBuilderInPeriod',
      //   tooltip: 'The total number of active published traditional editor sites for builder brands on the selected end date'
      // },
      // {
      //   title: 'Total number of active published sites Traditional Editor Hosting',
      //   type: CHART_TYPES.CARD,
      //   name: 'TotalActivePublishedSitesTraditionalHostingInPeriod',
      //   tooltip: 'Total number of active published traditional editor sites for hosting brands on the selected end date'
      // },
      // {
      //   title: 'Total number of active published sites Express Editor',
      //   type: CHART_TYPES.CARD,
      //   name: 'totalActivePublishedSitesExpressInPeriod',
      //   tooltip: 'Total number of active published express editor sites within the selected date range'
      // },
      {
        title: 'Saved sites Express Editor',
        type: CHART_TYPES.GRAPH,
        name: 'createdSitesExpress',
        customFormat: CHART_TYPES.BRAND_SITES,
        visible: ['SinglePlatform', 'SiteBuilder', 'WebsiteBuilder', 'Sitey', 'Sitelio', 'ConstantContact', 'Domain.com', 'BlueHost', 'Bluehost', 'Gator'],
        tooltip:
          'A graph representing the newly saved sites in a specific date range. Shows the 4 main brands + SinglePlatform by default.'
      },
      {
        title: 'Saved sites Traditional Editor',
        type: CHART_TYPES.GRAPH,
        name: 'createdSitesTraditional',
        customFormat: CHART_TYPES.BRAND_SITES,
        visible: ['SinglePlatform', 'SiteBuilder', 'WebsiteBuilder', 'Sitey', 'Sitelio', 'Gator', 'Domain.com'],
        tooltip:
          'A graph representing the newly saved sites in a specific date range. Shows the 4 main brands + Gator by default.'
      },
      {
        title: 'Time to first publish Express Editor',
        type: CHART_TYPES.HEAT_TABLE,
        name: 'timetofirstpublishexpress',
        tooltip: [
          'Time between the Creation date of an account and the First time an Express Editor site is published for that account.',
          'This chart only takes accounts with a saved express site into account (leaving out accounts without a site or only a traditional site).',
          'The number of accounts includes both Builder and Hosting brands.'
        ]
      },
      {
        title: 'Time to first paid Express Editor',
        type: CHART_TYPES.HEAT_TABLE,
        name: 'timetofirstpaidExpress',
        tooltipFormatterVerb: 'paid',
        tooltip: [
          'Time between the Creation date of an account and the moment a paid plan is bought for an Express Editor site.',
          'This chart only takes accounts with a saved site into account (leaving out accounts without a site or only a traditional site).',
          "The number of accounts includes Builder brands, but doesn't contain Hosting brands."
        ]
      },
      {
        title: 'Time to first publish Traditional Editor',
        type: CHART_TYPES.HEAT_TABLE,
        name: 'timetofirstpublishtraditional',
        tooltip: [
          'Time between the Creation date of an account and the First time a Traditional Editor site is published for that account.',
          'This chart only takes accounts with a traditional site into account (leaving out accounts without a site or only a express editor site).',
          'The number of accounts includes both Builder and Hosting brands.'
        ]
      },
      {
        title: 'Time to first paid Traditional Editor',
        type: CHART_TYPES.HEAT_TABLE,
        name: 'timetofirstpaidTraditional',
        tooltipFormatterVerb: 'paid',
        tooltip: [
          'Time between the Creation date of an account and the moment a paid plan is bought for a traditional site. ',
          'This chart only takes accounts with a saved site into account (leaving out accounts without a site or only a express editor site)..',
          "The number of accounts includes Builder brands, but doesn't contain Hosting brands."
        ]
      },
      {
        title: 'New published sites Express',
        type: CHART_TYPES.TABLE,
        name: 'NewPublishedExpress',
        headers: [
          { name: 'TimePublished', title: 'Time published', type: 'datetime' },
          { name: 'SiteUrl', title: 'Site Url', type: 'url' },
          { name: 'InsightsKey', title: 'Insights', type: 'insights' },
          { name: 'AccountId', title: 'Account Id', type: 'account' },
          { name: 'BrandGroupName', title: 'Brand', type: '' },
          { name: 'FirstName', title: 'First Name', type: '' },
          { name: 'LastName', title: 'Last Name', type: '' },
          { name: 'Email', title: 'Email', type: '' },
          { name: 'Phone', title: 'Phone', type: '' }
        ],
        tooltip: ['Displays the newly published Express websites in the given timeframe'],
        sorting: { default: { fieldNames: ['TimePublished'], direction: false } },
        limit: 500
      },
      {
        title: 'New published sites Traditional',
        type: CHART_TYPES.TABLE,
        name: 'NewPublishedTraditional',
        headers: [
          { name: 'TimePublished', title: 'Time published', type: 'datetime' },
          { name: 'SiteUrl', title: 'Site Url', type: 'url' },
          { name: 'InsightsKey', title: 'Insights', type: 'insights' },
          { name: 'AccountId', title: 'Account Id', type: 'account' },
          { name: 'BrandGroupName', title: 'Brand', type: '' },
          { name: 'FirstName', title: 'First Name', type: '' },
          { name: 'LastName', title: 'Last Name', type: '' },
          { name: 'Email', title: 'Email', type: '' },
          { name: 'Phone', title: 'Phone', type: '' }
        ],
        tooltip: ['Displays the newly published Traditional websites in the given timeframe'],
        sorting: { default: { fieldNames: ['TimePublished'], direction: false } },
        limit: 500
      }
      // {
      //   title: 'Time to first publish Traditional Editor',
      //   type: CHART_TYPES.HEAT_TABLE,
      //   name: 'timetofirstpublishtraditional',
      //   tooltip: [
      //     'Time between the Creation date of an account and the First time a Traditional Editor site is published for that account.',
      //     'This chart only takes asccounts with a traditional site into account (leaving out accounts without a site or only a express editor site).'
      //   ]
      // }
      // ,
      // {
      //   title: 'Published sites',
      //   type: CHART_TYPES.CARD,
      //   name: 'publishedSites'
      // },
      // {
      //   title: 'Published sites direct brands',
      //   type: CHART_TYPES.CARD,
      //   name: 'publishedSitesDirectBrands'
      // },
      // {
      //   title: 'Published sites hosting brands',
      //   type: CHART_TYPES.CARD,
      //   name: 'publishedSitesHostingBrands'
      // },
      // {
      //   title: 'First time publishing',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'firstTimePublishing'
      // },
      // {
      //   title: 'Republishing',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'rePublishing'
      // },
      // {
      //   title: 'First time publishing by brand',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'firstTimePublishingByBrand'
      // },
      // {
      //   title: 'Republishing by brand',
      //   type: CHART_TYPES.GRAPH,
      //   name: 'rePublishingByBrand'
      // }
    ],
    route: '/financial-reports/site/published',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.DOMAINCOM.id, Partners.BLUEHOST.id, Partners.BIGROCK.id]
  },
  reportingSitesTraffic: {
    hideGroupBy: true,
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          "These stats are updated every hour. The stats below show data for <brands all>. Express Editor charts are not displayed yet, as there's not enough data present. Only sites that have visitors each month are taken into account"
      },
      // {
      //   title: 'Avg. visitors per tracked site',
      //   type: CHART_TYPES.CARD,
      //   name: 'AverageVisitorsPerTrackedSite',
      //   className: 'grid-col-3'
      // },
      // {
      //   title: 'Avg. bounce rate per tracked site',
      //   type: CHART_TYPES.CARD,
      //   name: 'AverageBounceRatePerTrackedSite',
      //   className: 'grid-col-3'
      // },
      // {
      //   title: 'Avg. page views per tracked site',
      //   type: CHART_TYPES.CARD,
      //   name: 'AveragePageViewsPerTrackedSite',
      //   className: 'grid-col-3'
      // },
      // {
      //   title: 'Avg. active pages per tracked site',
      //   type: CHART_TYPES.CARD,
      //   name: 'AverageActivePagesPerTrackedSite',
      //   className: 'grid-col-3'
      // },
      // {
      //   title: 'Sites with traffic',
      //   type: CHART_TYPES.STACKED,
      //   name: 'SitesWithTraffic',
      //   tooltipLabel: 'sites'
      // },
      // {
      //   title: 'Top Countries',
      //   type: CHART_TYPES.WORLD_MAP,
      //   name: 'topCountriesMap',
      //   className: 'grid-col-12'
      // },
      // {
      //   title: 'Top Countries',
      //   type: CHART_TYPES.PIE,
      //   name: 'topCountriesDonut',
      //   tooltipLabel: 'stores'
      // },
      // {
      //   title: 'Top site visitors',
      //   type: CHART_TYPES.PIE,
      //   name: 'TopSiteVisitors',
      //   tooltipLabel: 'sites',
      //   className: 'grid-col-6',
      //   tooltip: ''
      // },
      // {
      //   title: 'Top languages',
      //   type: CHART_TYPES.PIE,
      //   name: 'topLanguages',
      //   tooltipLabel: 'stores'
      // },
      // {
      //   title: 'Top browsers',
      //   type: CHART_TYPES.PIE,
      //   name: 'topBrowsers',
      //   tooltipLabel: 'stores'
      // },
      // {
      //   title: 'Device visitors',
      //   type: CHART_TYPES.PIE,
      //   name: 'deviceVisitors',
      //   tooltipLabel: 'stores'
      // },

      {
        title: 'Most active sites Express Editor',
        type: CHART_TYPES.TABLE,
        name: 'traffictopsitesexpress',
        tooltip: 'Displays the top 50 active Express sites.',
        sorting: { default: { fieldNames: ['Visitors'], direction: false } },
        limit: 500
      },
      {
        title: 'Most active sites Traditional',
        type: CHART_TYPES.TABLE,
        name: 'traffictopsitestraditional',
        tooltip: 'Displays the top 50 active Traditional sites.',
        sorting: { default: { fieldNames: ['Visitors'], direction: false } },
        limit: 500
      },
      {
        title: 'Visitor stats traditional - Sites Published in 2017',
        type: CHART_TYPES.GRAPH,
        name: 'visitorstatstraditional2yearsago',
        disableBrands: true,
        userFriendlyLabels: true,
        visible: ['FirstQuartilePaid', 'MedianPaid', 'ThirdQuartilePaid'],
        tooltip: [
          'This graph shows the visitor stats for all Traditional sites first published between Jan 1st 2017 and Jan 1st 2018 which have at least 1 visitor for each month.',
          'Month 1 is the first new month after the site was published.'
        ]
      },
      {
        title: 'Visitor stats traditional - Sites Published in first half of 2018',
        type: CHART_TYPES.GRAPH,
        name: 'visitorstatstraditional1yearago',
        disableBrands: true,
        userFriendlyLabels: true,
        visible: ['FirstQuartilePaid', 'MedianPaid', 'ThirdQuartilePaid'],
        tooltip: [
          'This graph shows the visitor stats for all Traditional sites first published between Jan 1st 2018 and Jul 1st 2018 which have at least 1 visitor for each month.',
          'Month 1 is the first new month after the site was published.'
        ]
      }
    ],
    route: '/financial-reports/site/traffic',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.DOMAINCOM.id, Partners.BLUEHOST.id, Partners.BIGROCK.id]
  }
}
